import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { GoogleDriveService } from "@/services/cloud/GoogleDriveService";
import { CloudConnection } from "@/types/cloud";

export const useGoogleDriveConnection = () => {
  const queryClient = useQueryClient();

  // Query for connection status
  const {
    data: status,
    isLoading: isLoadingStatus,
    error: statusError,
  } = useQuery<CloudConnection>({
    queryKey: ["google-drive-connection-status"],
    queryFn: () => GoogleDriveService.getConnectionStatus(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  // Mutation for disconnect
  const disconnectMutation = useMutation({
    mutationFn: () => GoogleDriveService.disconnect(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["google-drive-connection-status"] });
      toast.success("Google Drive disconnected");
    },
    onError: (error: any) => {
      toast.error(error.message || "Failed to disconnect Google Drive");
    },
  });

  const connect = () => {
    const oauthUrl = GoogleDriveService.getOAuthUrl();
    window.location.href = oauthUrl;
  };

  return {
    connected: status?.connected ?? false,
    email: status?.email,
    displayName: status?.displayName,
    connectedAt: status?.connectedAt,
    isLoading: isLoadingStatus,
    error: statusError,
    connect,
    disconnect: () => disconnectMutation.mutate(),
    isDisconnecting: disconnectMutation.isPending,
  };
};
